import React from 'react'
import Card from '../ui/Card'
import {Card as BsCard, Col} from 'react-bootstrap'
import {Link} from 'react-router-dom'

const Admin = () => {
    return (
         <Card>
            <div className="panel panel-default">
              <div className="panel-heading">
                    <div className="container">
                        <div id="packet_id" className="panel-title">
                            <h1 className="menu-title">Admin</h1>
                        </div>
                    </div>
                </div>

                <div className="panel-body">
                    <div className="container">
                        <br/>
                        <div className="row">
                            <Col xs={12} sm={6} xl={4} className="mb-4 d-flex align-items-stretch">
                                <BsCard variant="light"  style={{width: '100%'}} className="bg-white shadow-sm mb-4 admin-widget" >
                                    <BsCard.Header className="text-center">MARKS-ROOS & AUTHORIZATIONS</BsCard.Header>

                                    <BsCard.Body>
                                        <ul style={{listStyle: 'none'}}>
                                            <li><Link to="/admin/associations">Marks-Roos Authority-LOB Links</Link></li>
                                            <li><Link to="/admin/authorization-maintenance">Issue Authorization Maintenance</Link></li>
                                        </ul>
                                    </BsCard.Body>
                                </BsCard>
                            </Col>

                            <Col  xs={12} sm={6} xl={4} className="mb-4 d-flex align-items-stretch">
                                <BsCard variant="light"  style={{width: '100%'}} className="bg-white shadow-sm mb-4 admin-widget" >
                                    <BsCard.Header className="text-center">FILER REQUESTS</BsCard.Header>

                                    <BsCard.Body>
                                        <ul style={{listStyle: 'none'}}>
                                            <li><Link to="/admin/pending-association-requests">Filer (External User) Approval Requests</Link></li>
                                            <li><Link to="/admin/status-history-upload-documents">Report PDF & Document Quick Retrieval</Link></li>
                                             <li><Link to="/admin/issuer-filer-associations">Filing Request Override</Link></li>
                                        </ul>
                                    </BsCard.Body>
                                </BsCard>
                            </Col>

                            <Col  xs={12} sm={6} xl={4} className="mb-4 d-flex align-items-stretch">
                                <BsCard variant="light" style={{width: '100%'}} className="bg-white shadow-sm mb-4 admin-widget" >
                                    <BsCard.Header className="text-center">ELECTIONS DATA</BsCard.Header>

                                    <BsCard.Body>
                                        <ul style={{listStyle: 'none'}}>
                                            <li><Link to="/admin/state-election">State & Local Elections Database</Link></li>
                                        </ul>
                                    </BsCard.Body>
                                </BsCard>
                            </Col>
                        
                            <Col xs={12} sm={6} xl={4} className="mb-4 d-flex align-items-stretch">
                                <BsCard variant="light" style={{width: '100%'}} className="bg-white shadow-sm mb-4 admin-widget" >
                                    <BsCard.Header className="text-center">CODE/TYPE MAINTENANCE </BsCard.Header>

                                    <BsCard.Body>
                                        <ul style={{listStyle: 'none'}}>
                                            <li><Link to="/admin/debt-instrument-maintenance">Debt Type Lookup/Edit</Link></li>
                                            <li><Link to="/admin/financing-purpose-maintenance">Issue Purpose Lookup/Edit</Link></li>
                                            <li><Link to="/admin/statute-maintenance">Issue Statute Maintenance</Link></li>
                                            <li><Link to="/admin/county-maintenance">County Maintenance</Link></li>
                                            <li><Link to="/admin/code-maintenance">Other Code Reference Lookup/Edit</Link></li>
                                        </ul>
                                    </BsCard.Body>
                                </BsCard>
                            </Col>
                            <Col xs={12} sm={6} xl={4} className="mb-4 d-flex align-items-stretch">
                                <BsCard variant="light" style={{width: '100%'}} className="bg-white shadow-sm mb-4 admin-widget" >
                                    <BsCard.Header className="text-center">ISSUER & ORG MAINTENANCE</BsCard.Header>

                                    <BsCard.Body>
                                        <ul style={{listStyle: 'none'}}>
                                            <li><Link to="/admin/issuer-maintenance">Issuer & Issuer Contact Maintenance</Link></li>
                                            <li><Link to="/admin/org-maintenance">Organization Contact Maintenance</Link></li>
                                            <li><Link to="/admin/organization-maintenance">Organization Maintenance</Link></li>
                                        </ul>
                                    </BsCard.Body>
                                </BsCard>
                            </Col>
                            <Col xs={12} sm={6} xl={4} className="mb-4 d-flex align-items-stretch">
                                <BsCard variant="light" style={{width: '100%'}} className="bg-white shadow-sm mb-4 admin-widget" >
                                    <BsCard.Header className="text-center">PRIOR REPORT UPDATES/CORRECTIONS</BsCard.Header>

                                    <BsCard.Body>
                                        <ul style={{listStyle: 'none'}}>
                                            <li><Link to="/admin/adtr-update">ADTR Principal Outstanding Corrections</Link></li>
                                            <li><Link to="/admin/adtr-authorization-update">ADTR Issuance Authorization Corrections</Link></li>
                                            <li><Link to="/admin/adtr-expenditure-update">ADTR Expenditure ONLY Corrections</Link></li>
                                            <li><Link to="/admin/proposed-debt-update">RPD Status & Other Updates</Link></li> 
                                        </ul>
                                    </BsCard.Body>
                                </BsCard>
                            </Col>
                            <Col xs={12} sm={6} xl={4} className="mb-4 d-flex align-items-stretch">
                                <BsCard variant="light" style={{width: '100%'}} className="bg-white shadow-sm mb-4 admin-widget" >
                                    <BsCard.Header className="text-center">ADVANCED REPORT UPDATES (PASSWORD)</BsCard.Header>

                                    <BsCard.Body>
                                        <ul style={{listStyle: 'none'}}>
                                            <li><Link to="/admin/final-sale-update">RFS Status & Other Updates</Link></li>
                                            <li><Link to="/admin/adtr-proceed-add">ADTR - Add Fund</Link></li>
                                            <li><Link to="/admin/adtr-authorization-add/Add">ADTR Authorization Update/Change</Link></li>
                                            <li><Link to="/admin/proposed-debt-issuer-update/Update">Update/Change Issuer - Report of Proposed</Link></li>
                                            <li><Link to="/admin/final-sale-issuer-update/Update">Update/Change Issuer - Report of Final Sale</Link></li>
                                        </ul>
                                    </BsCard.Body>
                                </BsCard>
                            </Col>
                            <Col xs={12} sm={6} xl={4} className="mb-4 d-flex align-items-stretch">
                                <BsCard variant="light" style={{width: '100%'}} className="bg-white shadow-sm mb-4 admin-widget" >
                                    <BsCard.Header className="text-center">BATCH PROCESSES (PASSWORD)</BsCard.Header>

                                    <BsCard.Body>
                                        <ul style={{listStyle: 'none'}}>
                                            <li><Link to="/admin/adtr-batch">ADTR Batch Process</Link></li>
                                            <li><Link to="/admin/adtr">Bulk Review Submitted ADTRs</Link></li>                                            
                                        </ul>
                                    </BsCard.Body>
                                </BsCard>
                            </Col>
                            <Col xs={12} sm={6} xl={4} className="mb-4 d-flex align-items-stretch">
                                <BsCard variant="light" style={{width: '100%'}} className="bg-white shadow-sm mb-4 admin-widget" >
                                    <BsCard.Header className="text-center">MANAGER ONLY (PASSWORD)</BsCard.Header>

                                    <BsCard.Body>
                                        <ul style={{listStyle: 'none'}}>
                                            <li><Link to="/admin/adtr-authorization-add/Review">Manager Review - ADTR Auth Update</Link></li>
                                            <li><Link to="/admin/proposed-debt-issuer-update/Review">Manager Review - RPD Change Issuer</Link></li>
                                            <li><Link to="/admin/final-sale-issuer-update/Review">Manager Review - RFS Change Issuer</Link></li>
                                            <li><Link to="/admin/fee-schedule-maintenance">Fee Schedule Maintenance</Link></li>
                                            <li><Link to="/admin/remittance-advice-template">Wire/ACH Instructions Template</Link></li>
                                            <li><Link to="/admin/debtwatch-configuration">DebtWatch FYE Dataset Update</Link></li>
                                            <li><Link to="/admin/admin-authorization-update">Admin UI - Set Password</Link></li>
                                        </ul>
                                    </BsCard.Body>
                                </BsCard>
                            </Col>
                        </div>
                    </div>
                </div>
            </div>
        </Card>
    )
}

export default Admin
